const requireAll = (r) => r.keys().forEach(r);
requireAll(require.context("./initializers/", true, /\.(js)$/));

import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import Redbox from "redbox-react";
import { debounce } from "lodash";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";

import store from "./store";
import Root from "./Root";

const history = syncHistoryWithStore(browserHistory, store);

// Hackfix for https://github.com/gaearon/react-hot-loader/issues/462
// delete AppContainer.prototype.unstable_handleError

const rootEl = document.getElementById("app");
const render = (Root) => {
  ReactDOM.render(
    <AppContainer errorReporter={Redbox}>
      <Root store={store} history={history} />
    </AppContainer>,
    rootEl
  );
};
render(Root);

if (module.hot) {
  /**
   * Warning from React Router, caused by react-hot-loader.
   * The warning can be safely ignored, so filter it from the console.
   * Otherwise you'll see it every time something changes.
   * See https://github.com/gaearon/react-hot-loader/issues/298
   */
  const orgError = console.error; // eslint-disable-line no-console
  console.error = (message) => {
    // eslint-disable-line no-console
    if (message && message.indexOf("You cannot change <Router routes>") !== -1) {
      return;
    }
    // Log the error as normally
    orgError.apply(console, [message]);
  };

  // Debounce it a little,
  // so in case we hotreload Root component AND RootEpic at the same time,
  // RootEpic gets reloaded first, and then the Root component
  // (if it's going to be done in the other way, we'll have our epics stopped,
  //  which might break ajax requests done on componentDidMount callbacks)
  module.hot.accept(
    "./Root",
    debounce(() => {
      // If you use Webpack 2 in ES modules mode, you can
      // use <App /> here rather than require() a <NextRoot />.
      const NextRoot = require("./Root").default;

      // This is needed to fix hmr - without it, it doesnt work after 1st hot reload.
      // It forces react to rerender the rootEl or something, im not sure.
      ReactDOM.unmountComponentAtNode(rootEl);
      rootEl.innerHTML = "";

      render(NextRoot);
    }),
    50
  );
}

export { store };



// WEBPACK FOOTER //
// ./src/app/index.js